import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import Swal from 'sweetalert2';
import { SectoresService } from '../services/sectores.service';
import { IComentarioItem, IComentarioRequest, IComentarioResponse } from '../interfaces/sector.interface';
import { SessionService } from 'src/app/shared/helpers/sesion.service';

@Component({
  selector: 'app-comentarios',
  templateUrl: './comentarios.component.html',
  providers: [MessageService]
})
export class ComentariosComponent implements OnInit, OnChanges {
  @Input() sector: string = '';
  @Input() descripcion: string = '';
  @Input() visible: boolean = false;

  @ViewChild('dt') table!: Table;
  
  dataSource: IComentarioItem[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  displayFormDialog: boolean = false;
  isEditMode: boolean = false;
  itemToEdit: IComentarioItem | null = null;

  displayedColumns = [
    { field: 'desde', header: 'Desde', sortable: true },
    { field: 'hasta', header: 'Hasta', sortable: true },
    { field: 'tipo', header: 'Tipo Estado', sortable: true },
    { field: 'fechaAlta', header: 'Fecha Alta', sortable: true },
    { field: 'fechaNota', header: 'Fecha Nota', sortable: true },
    { field: 'responsable', header: 'Responsable', sortable: true },
    { field: 'fuente', header: 'Fuente', sortable: true },
    { field: 'comentario', header: 'Comentario', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private sectoresService: SectoresService,
    private sessionService: SessionService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    // No cargar datos automáticamente al inicializar
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Solo cargar datos cuando el componente se vuelve visible y tiene un sector válido
    if (changes['visible'] && changes['visible'].currentValue === true && this.sector) {
      this.loadData();
    }
  }

  loadData(): void {
    if (!this.sector) return;

    this.loading = true;
    
    const request: IComentarioRequest = {
      sUsuario: this.sessionService.getUserSession(),
      que: 4,
      tope: '9999',
      sector: this.sector,
      sDesde: '',
      sHasta: '',
      tipoEstado: '',
      sFechaNota: '',
      fuente: '',
      comentario: '',
      odbc: 0
    };

    console.log('Request Comentarios:', request);

    this.sectoresService.getComentarios(request).subscribe({
      next: (response) => {
        console.log('Response Comentarios:', response);
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al cargar comentarios' });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar comentarios:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al cargar comentarios' });
        this.loading = false;
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  openNew(): void {
    this.isEditMode = false;
    this.itemToEdit = null;
    this.displayFormDialog = true;
  }

  onFormSaved(result: any): void {
    console.log('Resultado del formulario:', result);
    
    if (result.success) {
      this.messageService.add({ 
        severity: 'success', 
        summary: 'Éxito', 
        detail: result.message 
      });
      this.displayFormDialog = false;
      this.isEditMode = false;
      this.itemToEdit = null;
      this.loadData(); // Recargar la tabla
    } else {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Error', 
        detail: result.message 
      });
    }
  }

  onFormCancelled(): void {
    this.displayFormDialog = false;
    this.isEditMode = false;
    this.itemToEdit = null;
  }

  openEdit(item: IComentarioItem): void {
    this.itemToEdit = item;
    this.isEditMode = true;
    this.displayFormDialog = true;
  }

  openDelete(item: IComentarioItem): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro que desea eliminar el comentario del sector ${item.sector}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteComentario(item);
      }
    });
  }

  deleteComentario(item: IComentarioItem): void {
    this.loading = true;
    
    const userSession = this.sessionService.getUserSession();
    const sUsuario = userSession && userSession.trim() !== '' ? userSession : 'admin';
    
    const request = {
      sUsuario: sUsuario,
      que: 3, // Borrar
      tope: '',
      sector: item.sector,
      sDesde: item.desde,
      sHasta: item.hasta,
      tipoEstado: item.tipo,
      sFechaNota: item.fechaNota,
      fuente: item.fuente,
      comentario: item.comentario,
      odbc: item.odbc
    };

    console.log('Request Delete Comentario:', request);

    this.sectoresService.deleteComentario(request).subscribe({
      next: (response) => {
        console.log('Response Delete Comentario:', response);
        if (response.success && response.data) {
          this.messageService.add({ 
            severity: 'success', 
            summary: 'Éxito', 
            detail: 'Comentario eliminado correctamente' 
          });
          this.loadData(); // Recargar la tabla
        } else {
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Error', 
            detail: 'Error al eliminar el comentario' 
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al eliminar comentario:', error);
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Error al eliminar el comentario' 
        });
        this.loading = false;
      }
    });
  }
}
